import {WidgetDto} from '../../Models/Widgets/widget.interface';
import {FavoriteWidgetDto} from '../../Models/Widgets/favorite-widget.interface';
import {ItemModuleDto} from '../../Models/Module/module.interface';
import {FavoriteModuleDto} from '../../Models/Module/favorite-module.interface';

/**
 * Re-hidratar los widgets favoritos guardados contra su definición canónica
 *
 */
export function rehydrateFavoriteWidgets(storedWidgets: FavoriteWidgetDto[], widgets: WidgetDto[]): WidgetDto[] {
  const widgetsById = new Map(widgets.map((widget) => [widget.id, widget]));

  return storedWidgets.reduce<WidgetDto[]>((favorites, storedWidget) => {
    const widget = widgetsById.get(storedWidget.id);

    if (!widget) {
      return favorites;
    }

    const rehydrated: WidgetDto = {...widget, favorite: true};

    if (!widget.fullWidth && (storedWidget.col === 0 || storedWidget.col === 1)) {
      rehydrated.col = storedWidget.col;
    }

    favorites.push(rehydrated);
    return favorites;
  }, []);
}


/**
 * Reducir los widgets favoritos: identificador y columna
 *
 */
export function toFavoriteWidgets(widgets: WidgetDto[]): FavoriteWidgetDto[] {
  return widgets.map((widget) => {
    const favorite: FavoriteWidgetDto = {id: widget.id};

    if (!widget.fullWidth && (widget.col === 0 || widget.col === 1)) {
      favorite.col = widget.col;
    }

    return favorite;
  });
}


/**
 * Re-hidratar los accesos favoritos guardados contra su definición canónica
 *
 */
export function rehydrateFavoriteModules(storedItems: FavoriteModuleDto[], items: ItemModuleDto[]): ItemModuleDto[] {
  const itemsById = new Map(items.map((item) => [item.id, item]));

  return storedItems.reduce<ItemModuleDto[]>((favorites, storedItem) => {
    const item = itemsById.get(storedItem.id);

    if (item) {
      favorites.push({...item, favorite: true});
    }

    return favorites;
  }, []);
}


/**
 * Reducir los accesos favoritos a lo que decide el usuario: su identificador
 *
 */
export function toFavoriteModules(items: ItemModuleDto[]): FavoriteModuleDto[] {
  return items.map((item) => ({id: item.id}));
}
